<div
  class="form-item"
  [ngStyle]="{ width: width, 'justify-content': justifyContent }"
  [ngClass]="{ disabled: disabled }"
>
  <label [for]="id" class="form-item__label">{{ label }}</label>
  <hr class="form-item__separator" />
  <ng-content></ng-content>
</div>
